import React from 'react';
// TODO: To be deprecated
// import { InPersonTabContextProvider } from './InPersonTabContext';
import InPersonLayout from './InPersonTabLayout';

const InPersonTab: React.FC = () => <InPersonLayout />;

export default InPersonTab;
